import { throttle } from "lodash";
import { msalInstance } from "./instance";

export const logout = throttle(() => {
  msalInstance.logoutRedirect({
    onRedirectNavigate: () => false,
  });
}, 500);
